// External packages
import * as React from 'react';

// Components
import { MediaModal } from 'components/MediaModal';

// Types
import { Media } from '../../../../server/src/types/media.types';

type AddVideoModalProps = {
  modalTrigger?: React.ReactNode;
  video: Media;
  disableDelete?: boolean;
};

export const VideoModal: React.FC<AddVideoModalProps> = ({
  modalTrigger,
  video,
  disableDelete = false,
}) => (
  <MediaModal
    modalTrigger={modalTrigger}
    media={{ ...video, altText: video.altText ?? undefined }}
    fileType="videos"
    renderMedia={({ url }) => (
      <video
        width="320"
        height="240"
        controls
        className="max-h-[calc(100vh-9.5rem)] w-full h-full"
      >
        <source src={url} type="video/mp4" />
        <source src={url} type="video/ogg" />
        Vaš preglednik ne podržava video tag.
      </video>
    )}
    disableDelete={disableDelete}
  />
);
